import { decimal, percentage } from '../formatters';
import zeroReducer from './zeroReducer';

const labelCallback = context => {
    const yLabel = context.parsed.y;
    const dataArr = context.dataset.data;
    const total = dataArr.reduce((acc, el) => acc + el, 0);
    const formattedLabel = total
        ? `${decimal(yLabel)} (${percentage(yLabel / total)})`
        : 0;
    return formattedLabel;
};

const decimalConfig = () => {
    return {
        scales: {
            y: {
                beginAtZero: true,
                type: 'linear',
                display: true,
                position: 'left',
                grid: {
                    color: 'rgba(0,0,0,.08)',
                    zeroLineColor: 'rgba(0,0,0,.15)',
                },
                ticks: {
                    callback: val => {
                        return zeroReducer(val);
                    },
                    color: 'rgb(54, 162, 235)',
                },
            },
            y2: {
                beginAtZero: true,
                type: 'linear',
                display: true,
                position: 'right',
                grid: {
                    drawOnChartArea: false, // only want the grid lines for one axis to show up
                    color: 'rgba(0,0,0,0)',
                    zeroLineColor: 'rgba(0,0,0,.15)',
                },
                ticks: {
                    callback: val => {
                        return zeroReducer(val);
                    },
                    color: 'rgb(255, 99, 132)',
                },
            },
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: labelCallback,
                },
            },
        },
    };
};

export default decimalConfig;
